import React from "react";
import { Carousel } from "../../common/components/Carousel";
import { testimonialsType } from "../../common/types";
import { Testimonial } from "./Testimonial";

export function Testimonials({ testimonials }) {
	const productSlides = testimonials.map((item, index) => (
		<Testimonial key={index} item={item} />
	));

	if (testimonials.length === 0) {
		return null;
	}

	return (
		<section className="section--testimonials">
			<div className="container typography">
				<h2 className="section-title">
					Why 800+ companies like Airbus <br />
					and Delta trust ch-aviation
				</h2>

				<Carousel slides={productSlides} />
			</div>
		</section>
	);
}

Testimonials.propTypes = {
	testimonials: testimonialsType.isRequired,
};
